<template>
    <div>
        <TerrenoJuegoComponent 
            :direccion_campo="zona.direccion_campo ? zona.direccion_campo : 0"
            :tipo_recinto="zona.tipo_recinto"
        />

        <SelectorAsientosComponent
            :loading="loading"
            :filas="filas"
            :print_align="zona.print_align"
            :front="true"
            @butacaSeleccionada="toggleSeleccion(...arguments, true, true)"
        />

        <LeyendaButacasComponent/>
    </div>
</template>

<script>
    import TerrenoJuegoComponent from '../../../common/Asientos/TerrenoJuegoComponent.vue'
    import LeyendaButacasComponent from '../../../common/Asientos/LeyendaButacasComponent.vue'
    import SelectorAsientosComponent from '@/components/common/Asientos/SelectorAsientosComponent.vue'
    import comprobarButacas from "@/mixins/comprobarButacas";

    export default {
        props: [
            'zona',
            'asientos',
            'asientos_maximos',
            'puedo_cambiar',
            'forzar_adyacentes',
            'event',
            'abonadoId',
            'compra_invitaciones'
        ],
        mixins: [comprobarButacas],
        data() {
            return {
                loading: false,
                filas: null,
                datos_compradores: [],
                precios: null,
            }
        },
        created() {
            if (!this.compra_invitaciones) {
                this.getZona(this.zona.id)
            } else {
                this.filas = this.zona.configuracion_asientos;
            }
        },
        watch: {
            zona() {
                this.getZona(this.zona.id)
            },
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter
            },
            configuracion() {
                return this.$store.getters.getConfig
            },
        },
        methods: {
            getZona(id) {
                this.loading = true
                var params = null
                if (
                    this.$route.params.event_id != undefined &&
                    this.$route.params.sesion_id != undefined
                ) {
                    params = {
                        filters: {
                            zona_id: id,
                            conf: true,
                            evento_id: this.$route.params.event_id,
                            sesion_id: this.$route.params.sesion_id,
                            tid: this.configuracion.hash_teatro,
                            abonado_id: this.abonadoId
                        },
                        zona_id: id,
                    }
                } else {
                    params = {
                        filters: {
                            zona_id: id,
                            conf: true,
                        },
                    }
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.show'), params).then(res => {
                    this.filas = res.data.data.configuracion
                    this.precios = res.data.data.precios
                    this.loading = false
                    this.$emit('cargado');
                })            
            },
            toggleSeleccion: function(fila, asiento) {
                //lo anado a asientos_seleccionados
                //si no he seleccionado ninguna butaca y ademas tengo un abonado
                if (this.puedo_cambiar) {
                    for (var i in this.filas[fila]) {
                        if (
                            this.filas[fila][i].asiento == asiento &&
                            this.filas[fila][i].ocupado != 1 &&
                            this.filas[fila][i].ocupado != 3
                        ) {
                            if (this.filas[fila][i].seleccionado) {
                                //si el asiento estaba seleccionado, lo quito de datos_compradores
                                for (var j in this.datos_compradores) {
                                    if (
                                        this.datos_compradores[j].asiento.fila ==
                                        fila &&
                                        this.datos_compradores[j].asiento.asiento ==
                                        asiento
                                    ) {
                                        this.datos_compradores.splice(j, 1)
                                        this.filas[fila][i].seleccionado = false
                                    }
                                }
                            } else {
                                if (
                                    this.datos_compradores.length <
                                    (this.asientos_maximos ? this.asientos_maximos : 15)
                                ) {
                                    //si el asiento no estaba seleccionado es porque lo voy a anadir, asi que lo meto en datos_compradores
                                    var data = {
                                        asiento: {
                                            fila: fila,
                                            asiento: this.filas[fila][i].asiento,
                                            zona_id: this.zona.id,
                                            zona_nombre: this.zona.name,
                                        },

                                        nombre: '',
                                        apellidos: '',
                                        dni: '',
                                        telefono: '',
                                        precios: this.precios,
                                        url_imprimir: null,
                                        es_nuevo: true
                                    }

                                    if (!this.compra_invitaciones) {
                                        data.precio = this.precios[0];
                                    }

                                    //si tiene usuario relleno su informacion
                                    if (this.filas[fila][i].usuario) {
                                        data.n_abonado_antiguo =
                                            this.filas[fila][
                                                i
                                            ].usuario.n_abonado_antiguo
                                        data.es_nuevo = false
                                    }

                                    this.datos_compradores.push(data)
                                    this.filas[fila][i].seleccionado = true
                                } else {
                                    this.$toast.error(this.$t('eventos.error_limite_asientos') + ' (Máx: ' + this.asientos_maximos + ')');
                                }
                            }

                            while (this.asientos.length > 0) this.asientos.pop()
                            if (this.esConfiguracionAsientosValida()) {
                                for (var dato in this.datos_compradores) {
                                    this.asientos.push(this.datos_compradores[dato])
                                }
                            }
                        }
                    }
                    this.actualizarDatos()
                }

                var valido = true;

                if(this.event && this.event.comprobacion_butacas){
                    valido =  this.comprobarButacas(this.filas);
                }

                this.$emit('validoAsientos' , valido);
            
                this.$emit('changeAnySelected', this.datos_compradores.length !== 0)
            },
            actualizarDatos() {
                this.$emit('actualizarDatos', this.datos_compradores)
            },
            esConfiguracionAsientosValida() {
                if (!this.forzar_adyacentes) {
                    return true
                }

                for (var fila in this.filas) {
                    for (var i in this.filas[fila]) {
                        if (i == 0) continue

                        let actual = this.filas[fila][i]
                        let anterior = this.filas[fila][i - 1]
                        if (
                            (actual.seleccionado &&
                                !anterior.seleccionado &&
                                !anterior.ocupado) ||
                            (anterior.seleccionado &&
                                !actual.seleccionado &&
                                !actual.ocupado)
                        ) {
                            return false
                        }
                    }
                }
                return true
            }
        },
        components: {
            TerrenoJuegoComponent, LeyendaButacasComponent, SelectorAsientosComponent
        },
    }
</script>

<style>
    .filav {
        font-size: 10px;
    }

    @media screen and (max-width: 600px) {
        .margin-responsive {
            left: -8px;
        }
    }

    @media screen and (min-width: 1200px) {
        .margin-responsive {
            left: -25px;
        } 
    }
</style>
